export default __webpack_public_path__ + "images/5f0c2782cc4a75904b26dfe41ccc2099.png";